<template>
  <div class="app">
    <div class="divBox">
      <!-- <Header v-show="route.path != '/404' && route.path != '/EducationVideo'" /> -->
      <router-view />
      <!-- <Footer /> -->

      <!-- <Footer v-show="route.path != '/Birthday'" /> -->
      <Footer
        v-show="
          route.path != '/form' &&
          route.path != '/rule' &&
          route.path != '/formChange' &&
          route.path != '/festival' &&
          route.path != '/formFestival' &&
          route.path != '/formChangeFestival'
        "
      />
    </div>
  </div>
</template>

<script setup>
// import home from "./pages/home";
import Footer from "./components/Footer";
import { onMounted, watchEffect, reactive, computed, toRefs } from "vue";
import router from "@/router";
import { useRoute } from "vue-router";
// import { useStore } from "vuex";

const route = useRoute();
// const store = useStore();

const state = reactive({
  // btnChange: computed(() => store.state.header.showVideo),
});
const {} = toRefs(state);

const _isMobile = () => {
  let flag = navigator.userAgent.match(
    /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
  );
  return flag;
};

// 改变element-plus主题色
onMounted(() => {
  if (_isMobile()) {
    let doc = document.documentElement;
    const adapter = () => {
      // 获取布局视口宽度，因为开启了理想视口，布局视口=设备横向独立像素值
      const dpWidth = doc.clientWidth;
      // 计算跟字体大小
      const rootFontSize = (dpWidth * 100) / 750;
      doc.style.fontSize = rootFontSize + "px";
    };
    adapter();
  } else {
    let doc = document.documentElement;
    const adapter = () => {
      doc.style.fontSize = 60 + "px";
    };
    adapter();
  }
});
</script>

<style lang="less">
@import "@/styles/style.less";
.app {
  width: 100%;
  position: relative;
  .divBox {
    width: 750 * @fz;
    position: absolute;
    left: 50%;
    margin-left: -375 * @fz;
  }

  /* 隐藏水平滚动条 */
  ::-webkit-scrollbar {
    width: 0;
    height: 0;
  }

  /* 隐藏垂直滚动条 */
  ::-webkit-scrollbar-track {
    display: none;
  }
}
</style>
